export const modules = [
    { name: 'visitorAccess', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'levy', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'maintenance', permissions: ['create', 'read', 'update', 'delete', 'approve'] },
    { name: 'lease', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'vas', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'tickets', permissions: ['create', 'read', 'update', 'delete', 'review'] },
    { name: 'utility', permissions: ['create', 'read', 'update', 'delete', 'approve'] },
    { name: 'booking', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'handover', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'accounts', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'campaigns', permissions: ['create', 'read', 'update', 'delete'] },
    { name: 'procurement', permissions: ['create', 'read', 'update', 'delete', 'approve'] },
    { name: 'propertyManagement', permissions: ['create', 'read', 'update', 'delete', 'approve'] }
];

// 2️⃣ CORE CHECK FUNCTIONS — reusable anywhere
const hasModuleAccess = (userPermissions, moduleName) => {
    const module = userPermissions?.[moduleName];
    return module ? Object.values(module).some(val => val === true) : false;
};

const hasSpecificPermission = (userPermissions, moduleName, permission) => {
    return userPermissions?.[moduleName]?.[permission] === true;
};

const getAccessibleModules = (userPermissions) => {
    return modules.filter(m => hasModuleAccess(userPermissions, m.name));
};

export const usePermissions = () => {
    return (user) => {
        const perms = user?.permissions || {};
        // const isAdmin = user?.role === 'admin' || 'guard';
        const isAdmin = ['admin', 'guard', 'ninja'].includes(user?.role);

        return {
            // Generic check - if admin, always return true
            hasAccess: (moduleName, permission = 'read') =>
                isAdmin || hasSpecificPermission(perms, moduleName, permission),

            hasModuleAccess: (moduleName) =>
                isAdmin || hasModuleAccess(perms, moduleName),

            // Specific checks - if admin, always return true
            canCreate: (moduleName) =>
                isAdmin || hasSpecificPermission(perms, moduleName, 'create'),

            canRead: (moduleName) =>
                isAdmin || hasSpecificPermission(perms, moduleName, 'read'),

            canUpdate: (moduleName) =>
                isAdmin || hasSpecificPermission(perms, moduleName, 'update'),

            canDelete: (moduleName) =>
                isAdmin || hasSpecificPermission(perms, moduleName, 'delete'),

            canApprove: (moduleName) =>
                isAdmin || hasSpecificPermission(perms, moduleName, 'approve'),

            canReview: (moduleName) =>
                isAdmin || hasSpecificPermission(perms, moduleName, 'review'),

            // For building nav menus dynamically - if admin, return all modules
            getAccessibleModules: () =>
                isAdmin ? modules : getAccessibleModules(perms),
        };
    };
};